module.exports = __webpack_public_path__ + "img/gl.48bf3e4e.svg";